export const Datenschutz = () => {
    return (
        <div className="section-padding container-custom min-h-screen !pt-48 pb-20">
            <h1 className="text-3xl md:text-5xl font-semibold text-[#F1F5F9] mb-12 font-['DM_Sans']">
                Datenschutzerklärung
            </h1>

            <div className="space-y-8 text-[#94A3B8] max-w-3xl leading-relaxed">
                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">1. Datenschutz auf einen Blick</h2>
                    <h3 className="text-lg text-[#F1F5F9] font-medium mb-2">Allgemeine Hinweise</h3>
                    <p className="mb-4">
                        Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                    </p>
                    <h3 className="text-lg text-[#F1F5F9] font-medium mb-2">Datenerfassung auf dieser Website</h3>
                    <p className="mb-2"><strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong></p>
                    <p className="mb-4">
                        Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
                    </p>
                    <p className="mb-2"><strong>Wie erfassen wir Ihre Daten?</strong></p>
                    <p className="mb-4">
                        Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben oder uns per WhatsApp senden. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie die Website betreten.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">2. Hosting</h2>
                    <p className="mb-4">
                        Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
                    </p>
                    <h3 className="text-lg text-[#F1F5F9] font-medium mb-2">Vercel</h3>
                    <p className="mb-4">
                        Anbieter ist die Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA.
                        Wenn Sie unsere Website besuchen, erfasst Vercel verschiedene Logfiles inklusive Ihrer IP-Adressen.
                        Vercel ist nach dem „EU-US Data Privacy Framework“ (DPF) zertifiziert. Das DPF ist ein Übereinkommen zwischen der Europäischen Union und den USA, das die Einhaltung europäischer Datenschutzstandards bei Datenverarbeitungen in den USA gewährleisten soll.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
                    <h3 className="text-lg text-[#F1F5F9] font-medium mb-2">Datenschutz</h3>
                    <p className="mb-4">
                        Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                    </p>
                    <h3 className="text-lg text-[#F1F5F9] font-medium mb-2">Hinweis zur verantwortlichen Stelle</h3>
                    <p className="mb-4">
                        Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
                        Praesidium Protection<br />
                        Magomed Tutaev<br />
                        Hegaustraße 26<br />
                        78239 Rielasingen-Worblingen<br />
                        Telefon: +41 77 993 89 89<br />
                        E-Mail: info@praesidium-protection.ch
                    </p>
                </section>

                <section>
                    <h2 className="text-xl text-[#F1F5F9] font-medium mb-4">4. Datenerfassung auf dieser Website</h2>
                    <h3 className="text-lg text-[#F1F5F9] font-medium mb-2">Kontaktanfragen via WhatsApp</h3>
                    <p className="mb-4">
                        Wenn Sie uns per WhatsApp kontaktieren, übermitteln Sie uns automatisch Ihre Telefonnummer und ggf. Ihren Namen sowie weitere Daten, die Sie im Chat preisgeben. Diese Daten nutzen wir ausschließlich zur Bearbeitung Ihrer Anfrage oder für die Kommunikation im Rahmen eines Auftrags.
                        Bitte beachten Sie, dass WhatsApp Inc. (Meta Platforms) eigene Datenschutzrichtlinien hat und Daten auch in den USA verarbeitet werden können. Wir empfehlen, keine sensiblen persönlichen Daten (wie Gesundheitsdaten oder Bankverbindungen) unverschlüsselt über WhatsApp zu versenden.
                    </p>
                </section>
            </div>
        </div>
    );
};

